import api from './index'

export function toggleFastLoad(data, params = {}) {
  return api.post(`/account/fast_load/`, data, { params })
}
